import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../../store/actions/profileActions';
import SettingsLayout from '../../../containers/SettingsLayout';
import RadioChipContainer from '../../Profile/elements/RadioChipContainer';

const Preferences = () => {
    const preferenceFilters = useSelector(state => state.profile.preferenceFilters);
    const dispatch = useDispatch();
    const campuses = ['Everyone','APK','APB','SWC','DFC'];

    const handleChange = newValue => {
        dispatch(actions.preferenceFilterUpdate({...preferenceFilters, age: newValue}));
    }

    useEffect(() => {
        if (preferenceFilters === null) {
            dispatch(actions.preferenceFilterUpdate({...preferenceFilters, age: 30}));
        }
    }, [])

    return (
        <SettingsLayout>
            <div className="content-row">
                <div className="content-title">
                    <h1>Preferences</h1>
                </div>

                <div className="preference-blocks">
                    <div className="preference-content">
                        <div className="uni-slider">
                            <div className="age-label">
                                <h5>Age Range</h5>
                                <p>18 - {preferenceFilters !== null ? preferenceFilters.age : 30}</p>    
                            </div>
                            <input 
                                type="range" className="preference-slider-input" color="#41004C" 
                                name="height" value={preferenceFilters !== null ? preferenceFilters.age : 30} 
                                onChange={e => handleChange(e.target.value)} min="18" max="100" />
                        </div>
                    </div>
                    <div className="preference-content" style={{marginTop: '15px'}}>
                        <h5>Preferred Campus</h5>
                        <RadioChipContainer labels={campuses} type="preferenceFilters" /> 
                    </div>
                </div>
            </div>
        </SettingsLayout>
    );
}

export default Preferences
